/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react';

const PDFComponent = React.forwardRef(
  (
    {
      block, // eslint-disable-line no-unused-vars
      blockProps, // eslint-disable-line no-unused-vars
      customStyleMap, // eslint-disable-line no-unused-vars
      customStyleFn, // eslint-disable-line no-unused-vars
      decorator, // eslint-disable-line no-unused-vars
      forceSelection, // eslint-disable-line no-unused-vars
      offsetKey, // eslint-disable-line no-unused-vars
      selection, // eslint-disable-line no-unused-vars
      tree, // eslint-disable-line no-unused-vars
      contentState, // eslint-disable-line no-unused-vars
      blockStyleFn, // eslint-disable-line no-unused-vars
      preventScroll, // eslint-disable-line no-unused-vars
      style,
      ...elementProps
    },
    ref,
  ) => {
    const [isBig, expand] = useState(false);
    return (
      <>
        <button onClick={() => expand(!isBig)} aria-label="toggle size" type="button">
          <i className={`fas ${isBig ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt'}`} />
        </button>
        <div style={{ width: `${blockProps.width}%` }} className={isBig ? 'min-width iframe-resizer' : 'min-width pdf'}>
          <iframe src={blockProps.src} type="application/pdf" width="100%" title={block.key}>
            <p><a href={blockProps.src}>Link to PDF</a></p>
          </iframe>
        </div>
      </>
    );
  },
);
PDFComponent.displayName = 'PDFComponent';

export default PDFComponent;
